import { render, staticRenderFns } from "./Modulos.vue?vue&type=template&id=194b7447&scoped=true"
import script from "./Modulos.vue?vue&type=script&lang=ts"
export * from "./Modulos.vue?vue&type=script&lang=ts"
import style0 from "./Modulos.vue?vue&type=style&index=0&id=194b7447&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194b7447",
  null
  
)

export default component.exports